import { IDmNganh } from "../../model/respone/category/IDmNganh";
import { apiClient } from "../apiClient";

export const NGANH_ENDPOINT = "nganh";
export const nganhApi = {
  SelectAll: () => apiClient.get(`${NGANH_ENDPOINT}`),
  Insert: (payload: IDmNganh) => apiClient.post(`${NGANH_ENDPOINT}`, payload),
  Update: (payload: IDmNganh) => apiClient.put(`${NGANH_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${NGANH_ENDPOINT}/${id}`),
};
